module.exports = __webpack_public_path__ + "img/脸型精修--多种款式gif.7a0e023e.gif";